export function test (value) {
  return value + 'dasdasd'
}



// WEBPACK FOOTER //
// ./src/common/filter/index.js